import React, { memo } from 'react';

import Badge from 'react-bootstrap/Badge';

import _compact from 'lodash/compact';
import _forEach from 'lodash/forEach';
import _map from 'lodash/map';
import _some from 'lodash/some';

import { CONSTANTS } from '../../../utils/common';

const MAX_LEVEL = CONSTANTS.topic_hierarchy_max_level;

export const isTopicValid = (topics) => {
  if (_some(topics, 'selected')) return true;
  let ret = false;

  _forEach(topics, (topic) => {
    if (isTopicValid(topic.children)) {
      ret = true;
      return false;
    }
    return undefined;
  });
  return ret;
};

const renderBadge = (key, selected, label, onToggleOff) => (
  <h6 key={`h${key}`} className='chip-area'>
    <Badge key={key} variant={selected ? 'primary' : 'secondary'} pill>
      <span>{label}</span>
      <span
        className='close-button'
        onClick={(event) => {
          event.stopPropagation();
          onToggleOff(key);
        }}
      >
        (x)
      </span>
    </Badge>
  </h6>
);

const renderNode = (node, level, idx, onToggleOff) => {
  const childSelected = _some(node.children, 'selected');
  let ret = [];

  if (node.selected || childSelected) {
    ret.push(renderBadge(node.key, node.selected, node.label, onToggleOff));
  }

  if (node.children.length > 0 && childSelected && level < MAX_LEVEL) {
    ret.push(<span key={`spano${idx}`}>[</span>);
    _forEach(node.children, (child, i) => {
      ret.push(renderNode(child, level + 1, idx * 100 + i, onToggleOff));
    });
    ret.push(<span key={`spanc${idx}`}>]</span>);
  }

  ret = _compact(ret);

  return ret.length > 0 ? ret : null;
};

/**
 * Recursive read-only render of the selected-topic tree shown inside the
 * Targeting input-group when Topic mode is active. Selecting topics happens in
 * the separate `TopicPicker` modal; this view only renders chips for what's
 * already selected and exposes a "(x)" remove-affordance per chip.
 *
 * Props
 *   rootTopic:   the root topic node (from NotificationContext) — { children }
 *   onToggleOff: (key: string) => void — called when the user clicks a chip's (x)
 */
const TopicTreeView = ({ rootTopic, onToggleOff }) => {
  if (!rootTopic || !isTopicValid(rootTopic.children)) {
    return <span>Click to choose topics</span>;
  }

  return _map(rootTopic.children, (node, idx) =>
    renderNode(node, 1, idx, onToggleOff)
  );
};

export default memo(TopicTreeView);
